import React from 'react';
import MuiAlert from '@mui/material/Alert';

// Alert component for use in the snackbar
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default Alert;
